module.exports = __webpack_public_path__ + "static/media/big-blog-thumb.af4502f1.jpg";